document.addEventListener("DOMContentLoaded", function () {
  const KLAVIYO_PUBLIC_API_KEY = "YAMVTt";
  const KLAVIYO_LIST_ID = "TrrAKZ";

  const klaviyoFooterForm = document.querySelector("#klaviyo-footer-form");
  const klaviyoFooterMessage = document.querySelector("#klaviyo-footer-message");

  console.log("Klaviyo form found:", klaviyoFooterForm);

  if (!klaviyoFooterForm || !klaviyoFooterMessage) return;

  klaviyoFooterForm.addEventListener("submit", async function (event) {
    event.preventDefault();

    console.log("Klaviyo form submitted with JS");

    const emailInput = klaviyoFooterForm.querySelector('input[name="email"]');
    const email = emailInput.value.trim();

    if (!email) return;

    klaviyoFooterMessage.textContent = "SUBMITTING...";

    try {
      const response = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_PUBLIC_API_KEY, {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          revision: "2024-10-15",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: KLAVIYO_LIST_ID,
                },
              },
            },
          },
        }),
      });

      const responseText = await response.text();

      console.log("Klaviyo status:", response.status);
      console.log("Klaviyo response:", responseText);

      if (!response.ok) {
        throw new Error(responseText || "Klaviyo subscription failed");
      }

      klaviyoFooterMessage.textContent = "THANK YOU FOR SUBSCRIBING.";
      klaviyoFooterForm.reset();
    } catch (error) {
      klaviyoFooterMessage.textContent = "SOMETHING WENT WRONG. PLEASE TRY AGAIN.";
      console.error("Klaviyo error:", error);
    }
  });
});
